/* Display-only companion for the existing automatic promotion. No cart or catalog writes. */
if (!customElements.get('sc-promo-price')) {
  customElements.define('sc-promo-price', class extends HTMLElement {
    connectedCallback() {
      this.checkTime = this.checkTime || (() => {
        clearTimeout(this.expiryTimer);
        const now = Date.now();
        const start = Number(this.dataset.start) * 1000;
        const end = Number(this.dataset.end) * 1000;
        if (!Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end) {
          const original = this.querySelector('template[data-sc-original]');
          if (original) this.replaceWith(original.content.cloneNode(true));
          return;
        }
        this.expiryTimer = setTimeout(this.checkTime, Math.min(end - now, 60000));
      });
      document.addEventListener('visibilitychange', this.checkTime);
      window.addEventListener('pageshow', this.checkTime);
      this.checkTime();
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.checkTime);
      window.removeEventListener('pageshow', this.checkTime);
    }
  });
}
